import axios from 'axios'
export default {
  postLogin: (authData) => axios.post('/jwt/token', authData),
  postRefreshToken: (refreshToken) => axios.post(`/jwt/token/refresh`, { refresh_token: refreshToken }),
  postRequestResetPassword: (recoveryMail) => axios.post('/users/request_password', recoveryMail),
  postResetPassword: (resetPasswordInfo) => axios.post(`/users/reset_password`, resetPasswordInfo),
  postActivateUserInvitations: (invitationData) => axios.post(`/users/activate_invitation`, invitationData),
  getResetPasswordToken: (token) => axios.get(`/users/password_token/${token}`),
    /*  Self Onboarding  */
    postActivateUserPublic: (activationToken) => axios.post('/users/activate_public_invitation', activationToken)

}
